import React from "react";

import { useTranslation } from "react-i18next";

import { isGeoblockActive } from "../../../utils/geoblock";
import { GeoFieldBase } from "../../form-fields/GeoField";
import { TextFieldBase } from "../../form-fields/TextField";

import type { JSX } from "react";

import type {
  GeoblockMode,
  GeoCountry,
  GeoCountryGroup,
} from "../../../api/geoblock.types";
import type { StorefrontProjectParams } from "../../../api/ProjectAPI.types";
import type { GeoSelection } from "../../form-fields/GeoField";

interface GeoblockingConfigurationProps {
  geoblockMode: GeoblockMode;
  countries: GeoCountry[];
  countryGroups: GeoCountryGroup[];
  redirectUrl: string;
  onChange: <K extends keyof StorefrontProjectParams>(
    key: K,
    value: StorefrontProjectParams[K],
  ) => void;
}

export default function GeoblockingConfiguration({
  geoblockMode,
  countries,
  countryGroups,
  redirectUrl,
  onChange,
}: GeoblockingConfigurationProps): JSX.Element {
  const { t } = useTranslation("editor-platform");

  return (
    <div className="editor-form-section section-separator">
      <div className="flex max-w-125 flex-col gap-4">
        <GeoFieldBase
          geoblockMode={geoblockMode}
          selectedCountries={countries}
          selectedCountryGroups={countryGroups}
          onModeChange={(mode: GeoblockMode): void => {
            onChange("geoblock_mode", mode);
          }}
          onSelectionChange={(selection: GeoSelection): void => {
            onChange("countries", selection.countries);
            onChange("country_groups", selection.countryGroups);
          }}
        />
        <TextFieldBase
          description={t("geoblockRedirectUrlDescription")}
          disabled={!isGeoblockActive(geoblockMode)}
          label={t("geoblockRedirectUrl")}
          placeholder={t("placeholderGeoBlockRedirectUrl")}
          value={redirectUrl}
          onChange={(value: string): void => {
            onChange("geoblock_redirect_url", value);
          }}
        />
      </div>
    </div>
  );
}
